import React from 'react';
import { PropTypes } from 'prop-types';
import DropdownList from '../dropdown-list';

const CourseTypeSelector = ({ onChange, options }) => (
    <DropdownList
        name="courseTypeSelector"
        onChange={(name, value) => onChange(value)}
        optionKey="key"
        options={options}
        optionText="value" />);

CourseTypeSelector.propTypes = {
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired
};

CourseTypeSelector.defaultProps = {
    onChange: () => {},
    options: []
};

export default CourseTypeSelector;



// WEBPACK FOOTER //
// ./app/components/course-type-selector/course-type-selector.js